const ui_green_color = '#09aa5c';
const point_red_color = '#ff5252';
const font_weight_medium = 500;
const breakpoint_tablet = '600px';
const breakpoint_desktopS = '1152px';
const header_max_width = '1080px';
const header_height = '56px';
const content_max_width = '1080px';
const content_max_width_desktop = '681px';
const content_min_width_desktop = '375px';
const content_max_width_mobile = '568px';

export { breakpoint_desktopS, breakpoint_tablet, content_max_width, content_max_width_desktop, content_max_width_mobile, content_min_width_desktop, font_weight_medium, header_height, header_max_width, point_red_color, ui_green_color };
